import { FormBase } from 'core/components';

export default class UploadDocumentForm extends FormBase {
	constructor(hooks) {
		super(hooks);
		this.setForm(this);
	}
	setup() {
		return {
			fields: [
				{
					name: 'documentType',
					label: 'FULFILLMENTORDER.UPLOADDOCUMENTMODAL.DOCUMENTTYPE',
					rules: 'required',
				},
				{
					name: 'file',
					label: 'FULFILLMENTORDER.UPLOADDOCUMENTMODAL.FILE',
					rules: 'required',
				},
				// The shipping-label fields below only apply to the Shipping Label type; the view store
				// turns their rules on and off as the type changes.
				{
					name: 'trackingNumber',
					label: 'FULFILLMENTORDER.UPLOADLABELMODAL.TRACKINGNUMBER',
				},
				{
					name: 'carrierServiceId',
					label: 'FULFILLMENTORDER.UPLOADLABELMODAL.CARRIERSERVICE',
				},
				{
					name: 'carrierId',
					label: 'FULFILLMENTORDER.UPLOADLABELMODAL.CARRIER',
				},
				{
					name: 'shippingCost',
					label: 'FULFILLMENTORDER.UPLOADLABELMODAL.SHIPPINGCOST',
					rules: 'numeric|decimalLength|numericMinValue|invalidCharacter',
				},
			],
		};
	}
}
